import { MYEXAM } from './types';

export default {
  faceCheckGetter(state) {
    const myExam = state[MYEXAM];
    const obj = {
      precount: 0, // 考前验证的次数
      count: 0, // 考中验证的次数
      prepassed: false, // 考前是否通过
      passed: false, // 考中是否通过，但应该根据本地判断
      preuploaded: false, //考前是否已经录制过视频
    };
    if (myExam && JSON.stringify(myExam) !== '{}') {
      const checks = myExam.examinee_tencent_faces;
      if (Array.isArray(checks)) {
        checks.forEach((check) => {
          if (check.type === 1) { // 考试中
            obj.count += 1;
          }
          if (check.type === 2) { // 考前
            obj.precount += 1;
          }
        });
      }
      obj.preuploaded = myExam.examinee_videos.length > 0;
      obj.prepassed = myExam.examinee_tencent_face_testing;
      return obj;
    }
  },
};
